import {Button, Card, Descriptions, Divider, Spin, Table, Tag, Tooltip} from "antd";
import React from "react";
import {Link} from "react-router-dom";
import {sanitizeFieldName} from "../../util/methods";
import * as moment from "moment-timezone";

import ViewMeter from "./viewMeter";

class View extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { match, fetch } = this.props;
    if (match.params && match.params.id) {
      fetch(match.params.id);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps &&
      nextProps.data &&
      nextProps.data.pm &&
      JSON.stringify(nextProps.data) !== JSON.stringify(this.props.data)
    ) {
      const { data } = nextProps;
      const { asset, schedules, _id } = data.pm || {};
      if (asset && schedules && asset._id && schedules.length) {
        this.props.fetchLastProcessed(
          asset._id,
          schedules.map(si => si._id).toString(),
          _id
        );
      }
    }
  }

  render() {
    const {
      data,
      loading,
      title,
      resource,
      lastProcessedResource
    } = this.props;
    // const data = pmData.pm;
    // console.log(data);
    const {
      asset,
      complaint,
      createdBy,
      createdAt,
      schedules,
      hasProcessed,
      processedBy,
      processedOn
    } = data.pm || {};
    const tasks = (data && data["pm"] && data["pm"]["tasks"]) || [];

    const cols = [
      {
        title: "Sl.",
        dataIndex: "sl",
        key: "sl",
        render: (_, __, index) => index + 1
      },
      {
        title: "Code",
        dataIndex: "taskCode",
        key: "taskCode",
        render: (_, record) =>
          `${record.task && record.task.taskCode} [${record.schedule &&
            record.schedule.toString()}]`
      },
      {
        title: "Name",
        dataIndex: "taskName",
        key: "taskName",
        render: (_, record) => record.task && record.task.taskName
      },
      {
        title: "Instruction",
        dataIndex: "instruction",
        key: "instruction",
        width: 300,
        render: (_, record) => record && record.instruction
      },
      {
        title: "Compulsory",
        dataIndex: "compulsory",
        key: "compulsory",
        render: (_, record) =>
          record.task && record.task.allowToSkip ? (
            <Tag color="magenta">No</Tag>
          ) : (
            <Tag color="blue">Yes</Tag>
          )
      },
      {
        title: "Action",
        dataIndex: "action",
        key: "action",
        render: (_, record) => (
          <Tag color="#2db7f5">{record.actionTaken ? "Done" : ""}</Tag>
        )
      },
      {
        title: "Remark",
        dataIndex: "remark",
        key: "remark",
        width: 250,
        render: (_, record) => record.remark || ""
      },
      {
        title: "",
        dataIndex: "info",
        key: "info",
        width: 30,
        render: (_, record) => (
          <Tooltip
            title={
              record.actionTaken
                ? `Completed on : ${record.doneOn &&
                    moment(record.doneOn).format("DD-MM-YYYY hh:mm a")}
          By ${record.doneBy && record.doneBy.name}`
                : `Not completed yet!`
            }
          >
            <i
              style={{ color: "tomato" }}
              className="icon icon-exclamation gx-fs-sm"
            />
          </Tooltip>
        )
      }
    ];
    return (
      <Spin spinning={loading}>
        <Button>
          <Link to={`/pmchecklist`}>Back</Link>
        </Button>
        <Card
          ref={this.componentRef}
          className={`gx-card-metrics`}
          title={`${title} ${sanitizeFieldName(resource)}`}
        >
          <Descriptions title="Service Info" bordered>
            <Descriptions.Item label="Asset">
              <Link
                target={"_blank"}
                to={`/asset/history-report/${asset && asset._id}`}
              >
                {(asset && asset.assetCode) || "-"}
              </Link>
            </Descriptions.Item>
            <Descriptions.Item label="Location">
              {(asset && asset.location && asset.location.name) || "-"}
            </Descriptions.Item>
            <Descriptions.Item label="Sub Location">
              {(asset && asset.client && asset.client.name) || "-"}
            </Descriptions.Item>
            <Descriptions.Item label="Alt No ">
              {(asset && asset.altName) || "-"}
            </Descriptions.Item>
            <Descriptions.Item label="Service Identifier(Schedule)">
              {schedules &&
                schedules.map((si, inx) => (
                  <>
                    {inx > 0 ? <br /> : null}
                    <Link
                      key={`sch-${inx}`}
                      target={"_blank"}
                      to={`/pmschedule/edit/${si && si._id}`}
                    >
                      {(si && si.serviceIdentifierName) || "-"} (
                      {(si && si.serviceIdentifierNo) || "-"})
                    </Link>
                  </>
                ))}
            </Descriptions.Item>
            {/*<Descriptions.Item label="Complaint"><Link target={'_blank'}*/}
            {/*to={`/complaint/edit/${complaint && complaint._id}`}>{complaint && complaint.complaintNo || '-'}</Link></Descriptions.Item>*/}
            <Descriptions.Item label="JobCard">
              <Link
                target={"_blank"}
                to={`/job-card/report/${data.jobCard && data.jobCard._id}`}
              >
                {(data.jobCard && data.jobCard.jobCardNo) || "-"}
              </Link>
            </Descriptions.Item>
            <Descriptions.Item label="Created On">
              {createdAt && moment(createdAt).format("DD-MM-YYYY")}
            </Descriptions.Item>
            <Descriptions.Item label="Created By">
              {(createdBy && createdBy.name) || "-"}
            </Descriptions.Item>
            <Descriptions.Item label="Processed">
              {hasProcessed ? (
                <Tag color="blue">Yes</Tag>
              ) : (
                <>
                  <Tag color="tomato">No</Tag>
                  <Link
                    target="_blank"
                    to={`../process/${data && data["pm"] && data["pm"]["_id"]}`}
                  >
                    Process
                  </Link>
                </>
              )}
            </Descriptions.Item>
            <Descriptions.Item label="Processed On">
              {processedOn && moment(processedOn || "-").format("DD-MM-YYYY")}
            </Descriptions.Item>
            <Descriptions.Item label="Processed By">
              {(processedBy && processedBy.name) || "-"}
            </Descriptions.Item>
            <Descriptions.Item label="Service Person">
              {(data && data["pm"] && data["pm"]["servicePerson"]) || "-"}
            </Descriptions.Item>
            <Descriptions.Item label="Supervisor Name">
              {(data && data["pm"] && data["pm"]["supervisorName"]) || "-"}
            </Descriptions.Item>
            <Descriptions.Item label="Action">
              <Button
                type="primary"
                disabled={!(data && data["pm"] && data["pm"]["hasProcessed"])}
              >
                <Link
                  target="_blank"
                  to={`../print/${data && data["pm"] && data["pm"]._id}`}
                >
                  Print/Download
                </Link>
              </Button>
            </Descriptions.Item>
            <Descriptions.Item label="Code">
              {(data && data["pm"] && data["pm"].code) || "-"}
            </Descriptions.Item>
          </Descriptions>
          <Divider>Documents</Divider>
          <div>
            {(data &&
              data["pm"] &&
              data["pm"]["documents"] &&
              data["pm"]["documents"].length &&
              data["pm"]["documents"].map((item, ix) => (
                <div
                  key={ix}
                  style={{
                    marginTop: "10px",
                    border: "1px dashed #000",
                    padding: "20px",
                    borderRadius: "9px",
                    display: "flex"
                  }}
                >
                  {item.name} -{" "}
                  <span>
                    {item && item.file && item.file.path ? (
                      <a
                        href={item && item.file && item.file.path}
                        target="_blank"
                      >
                        {item && item.file && item.file.name}
                      </a>
                    ) : (
                      <span>{item && item.file && item.file.name}</span>
                    )}
                  </span>
                </div>
              ))) || <h5>No Documet found!</h5>}
          </div>
          <Divider>Meter Reading</Divider>
          <ViewMeter
            data={data}
            lastProcessedResource={lastProcessedResource}
          />
          <Divider>Tasks</Divider>
          <Table
            size={"small"}
            bordered
            pagination={false}
            dataSource={tasks}
            columns={cols}
            rowKey={(record, index) => `${record._id}_${index}`}
          />
        </Card>
      </Spin>
    );
  }
}

export default View;
